import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const VerifiedLicense: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.7409 16.6484H3.48029C2.05098 16.6484 0.887207 15.4846 0.887207 14.0553V2.64581C0.887207 1.2165 2.05098 0.0527344 3.48029 0.0527344H23.1877C24.617 0.0527344 25.7808 1.2165 25.7808 2.64581V11.9809C25.7808 12.2671 25.5484 12.4995 25.2621 12.4995C24.9759 12.4995 24.7435 12.2671 24.7435 11.9809V2.64581C24.7435 1.78802 24.0455 1.08996 23.1877 1.08996H3.48029C2.6225 1.08996 1.92444 1.78802 1.92444 2.64581V14.0553C1.92444 14.9131 2.6225 15.6112 3.48029 15.6112H10.7409C11.0272 15.6112 11.2595 15.8435 11.2595 16.1298C11.2595 16.4161 11.0272 16.6484 10.7409 16.6484Z"
        fill="currentColor"
      />
      <path
        d="M13.3344 11.4626C11.6188 11.4626 10.2227 10.0665 10.2227 8.35094C10.2227 6.63537 11.6188 5.23926 13.3344 5.23926C15.0499 5.23926 16.446 6.63537 16.446 8.35094C16.446 10.0665 15.0499 11.4626 13.3344 11.4626ZM13.3344 6.27649C12.1903 6.27649 11.2599 7.20688 11.2599 8.35094C11.2599 9.49501 12.1903 10.4254 13.3344 10.4254C14.4784 10.4254 15.4088 9.49501 15.4088 8.35094C15.4088 7.20688 14.4784 6.27649 13.3344 6.27649Z"
        fill="currentColor"
      />
      <path
        d="M19.0394 24.9469C15.3219 24.9469 12.2974 21.9223 12.2974 18.2049C12.2974 14.4874 15.3219 11.4629 19.0394 11.4629C22.7568 11.4629 25.7814 14.4874 25.7814 18.2049C25.7814 21.9223 22.7568 24.9469 19.0394 24.9469ZM19.0394 12.5001C15.8934 12.5001 13.3346 15.059 13.3346 18.2049C13.3346 21.3508 15.8934 23.9096 19.0394 23.9096C22.1853 23.9096 24.7441 21.3508 24.7441 18.2049C24.7441 15.059 22.1853 12.5001 19.0394 12.5001Z"
        fill="currentColor"
      />
      <path
        d="M18.002 20.7977C17.8651 20.7977 17.7323 20.7427 17.6348 20.6462L15.5604 18.5718C15.3581 18.3695 15.3581 18.0407 15.5604 17.8385C15.7626 17.6362 16.0914 17.6362 16.2937 17.8385L17.9761 19.5208L21.2413 15.7889C21.4301 15.5721 21.7578 15.5514 21.9736 15.7402C22.1893 15.9289 22.2111 16.2567 22.0223 16.4724L18.392 20.6214C18.2976 20.7292 18.1618 20.7935 18.0186 20.7977C18.0134 20.7977 18.0072 20.7977 18.002 20.7977Z"
        fill="currentColor"
      />
      <path
        d="M6.5921 4.20227H4.51764C4.23136 4.20227 3.99902 3.96993 3.99902 3.68365C3.99902 3.39738 4.23136 3.16504 4.51764 3.16504H6.5921C6.87838 3.16504 7.11072 3.39738 7.11072 3.68365C7.11072 3.96993 6.87838 4.20227 6.5921 4.20227Z"
        fill="currentColor"
      />
    </svg>
  )
})

VerifiedLicense.displayName = 'VerifiedLicense'
